import { SITE_VOICE } from '../siteVoice';

/** Standard 16-color ANSI escape demos (display strings are literal pedagogical notation). */
export const escapeDemoColorSequences = [
  { display: '^[[30m', desc: 'Black', effect: 'black', color: '#0a0a0a' },
  { display: '^[[31m', desc: 'Red', effect: 'red', color: '#f85149' },
  { display: '^[[32m', desc: 'Green', effect: 'green', color: '#22c55e' },
  { display: '^[[33m', desc: 'Yellow', effect: 'yellow', color: '#eab308' },
  { display: '^[[34m', desc: 'Blue', effect: 'blue', color: '#3b82f6' },
  { display: '^[[35m', desc: 'Magenta', effect: 'magenta', color: '#a855f7' },
  { display: '^[[36m', desc: 'Cyan', effect: 'cyan', color: '#06b6d4' },
  { display: '^[[37m', desc: 'White', effect: 'white', color: '#e5e5e5' },
  {
    display: '^[[90m',
    desc: 'Bright Black',
    effect: 'brightBlack',
    color: '#525252',
  },
  {
    display: '^[[91m',
    desc: 'Bright Red',
    effect: 'brightRed',
    color: '#ff7b72',
  },
  {
    display: '^[[92m',
    desc: 'Bright Green',
    effect: 'brightGreen',
    color: '#4ade80',
  },
  {
    display: '^[[93m',
    desc: 'Bright Yellow',
    effect: 'brightYellow',
    color: '#facc15',
  },
  {
    display: '^[[94m',
    desc: 'Bright Blue',
    effect: 'brightBlue',
    color: '#60a5fa',
  },
  {
    display: '^[[95m',
    desc: 'Bright Magenta',
    effect: 'brightMagenta',
    color: '#c084fc',
  },
  {
    display: '^[[96m',
    desc: 'Bright Cyan',
    effect: 'brightCyan',
    color: '#22d3ee',
  },
  {
    display: '^[[97m',
    desc: 'Bright White',
    effect: 'brightWhite',
    color: '#fafafa',
  },
] as const;

export const escapeDemoStyleSequences = [
  { display: '^[[1m', desc: 'Bold', effect: 'bold' },
  { display: '^[[4m', desc: 'Underline', effect: 'underline' },
  { display: '^[[0m', desc: 'Reset all styles', effect: 'reset' },
] as const;

export const escapeDemoCursorSequences = [
  { display: '^[[2J', desc: 'Clear entire screen', effect: 'clear' },
  { display: '^[[H', desc: 'Move cursor to home (0,0)', effect: 'home' },
  {
    display: '^[[5;10H',
    desc: 'Move cursor to row 5, col 10',
    effect: 'move',
  },
] as const;

export const escapeDemoUi = {
  palette16: '16-Color Palette',
  normalRange: 'Normal (30-37)',
  brightRange: 'Bright (90-97)',
  styleSequences: 'Style Sequences',
  cursorSequences: 'Cursor Sequences',
  preview: 'Preview',
  noSequencesActive: 'No escape sequences active',
  activePrefix: 'Active: ',
  placeholder: SITE_VOICE.escapePreviewPlaceholder,
  footerEsc: '^[',
  footerMidBeforeEscWord: ' represents the ',
  footerEscKeyword: 'ESC',
  footerAfterEscKeyword:
    ' character (byte 0x1B). The 16-color palette uses codes 30-37 for normal colors and 90-97 for bright variants.',
} as const;
